// extracted by mini-css-extract-plugin
export default {"hero_container":"O0","hero_pic_container":"P0","hero_pic":"Q0","hero_data_container":"R0","hero_data":"S0","hero_title":"T0","hero_text":"U0","hero_bottom_btn":"V0","hero_bottom_arrow":"W0"};
    if(module.hot) {
      // 1713912567704
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  